import api from "@/router/api";
import apiPublic from "@/router/apiPublic";

export default {
  async getAllVagas(page, size) {
    const response = await apiPublic.get("/vaga", {
      params: { page, size },
    });
    return response.data || response;
  },

  async getVagaById(vagaId) {
    const response = await apiPublic.get(`/vaga/${vagaId}`);
    return response.data || response;
  },

  async registrarCliqueInscricao(vagaId) {
    const response = await apiPublic.post(`/vaga/${vagaId}/clique-inscricao`);
    return response.data || response;
  },

  async registrarVisualizacao(vagaId) {
    const response = await apiPublic.post(`/vaga/${vagaId}/visualizacao`);
    return response.data || response;
  },

  async updateVaga(vagaId, payload) {
    const response = await api.put(`/vaga/${vagaId}`, payload);
    return response.data || response;
  },

  async deleteVaga(vagaId) {
    const response = await api.delete(`/vaga/${vagaId}`);
    return response.data;
  },

  async postVaga(acaoId, payload) {
    const response = await api.post(`/vaga/acao/${acaoId}`, payload);
    return response.data;
  },

  async getVagasFiltradas({
    page,
    size,
    titulo,
    texto,
    tag,
    dataInicial,
    dataFinal,
    status,
    acaoId,
    isBolsistaRemunerado,
    isCurricularizada,
    isEstagiario,
    unidadeId,
  }) {
    const params = {
      page,
      size,
      titulo,
      texto,
      tag,
      dataInicial,
      dataFinal,
      status,
      acaoId,
    };

    if (
      isBolsistaRemunerado !== undefined &&
      isBolsistaRemunerado !== null &&
      isBolsistaRemunerado !== ""
    ) {
      params.isBolsistaRemunerado = isBolsistaRemunerado;
    }

    if (
      isCurricularizada !== undefined &&
      isCurricularizada !== null &&
      isCurricularizada !== ""
    ) {
      params.isCurricularizada = isCurricularizada;
    }

    if (
      isEstagiario !== undefined &&
      isEstagiario !== null &&
      isEstagiario !== ""
    ) {
      params.isEstagiario = isEstagiario;
    }

    if (unidadeId !== undefined && unidadeId !== null && unidadeId !== "") {
      params.unidadeId = unidadeId;
    }

    const response = await apiPublic.get("/vaga/filtro", { params });
    return response;
  },
};
